import { Platform } from 'react-native';

/**
 * React Native Web renders TextInput as a native <input>, which inherits the
 * browser's focus outline (Chrome's dark ring). Spread this style onto any
 * input you don't want to show the default outline — we keep our own visual
 * focus state via border color.
 */
export const webNoOutline =
  Platform.OS === 'web'
    ? // The cast is necessary because react-native types don't include the
      // CSS-only properties RN Web supports.
      ({ outlineStyle: 'none', outlineWidth: 0 } as unknown as Record<string, unknown>)
    : null;

/**
 * Props (not styles) that suppress the browser's own autofill dropdown on
 * an RN-Web TextInput. Spread onto inputs that have their OWN suggestion
 * UI (the Places address autocomplete) — Chrome's address autofill panel
 * renders on top of ours and fills only the text, skipping the structured
 * zip/lat/lon a real suggestion pick provides.
 *
 * Why not `autocomplete="off"`: Chrome deliberately ignores "off" for
 * address-shaped fields. The reliable, widely-used workaround is an
 * UNRECOGNIZED token — the browser can't classify the field, so it shows
 * nothing. The data-* attributes opt out of the big password managers
 * (LastPass, 1Password, Dashlane) which otherwise inject their own icons.
 * Non-semantic id/name keep heuristics from re-classifying by field name.
 */
export function webNoAutofill(fieldKey: string): Record<string, unknown> {
  if (Platform.OS !== 'web') return {};
  return {
    autoComplete: 'homestead-off',
    id: `hs-${fieldKey}`,
    name: `hs-${fieldKey}`,
    'data-lpignore': 'true',
    'data-1p-ignore': 'true',
    'data-form-type': 'other',
  } as unknown as Record<string, unknown>;
}
